import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export default {
  install(app) {
    const page = usePage()

    // Define global computed values
    const user = computed(() => page.props.auth.user)
    const can = computed(() => page.props.can)
    const systemSettings = computed(() => page.props['system-settings'])
    const breakpoint = computed(() => page.props?.$vuetify?.display) // Adjust based on your setup

    // Provide these values globally
    app.provide('$user', user)
    app.provide('$can', can)
    app.provide('$systemSettings', systemSettings)
    app.provide('$breakpoint', breakpoint)
  }
}
